// eslint-disable-next-line import/no-unresolved
import * as processInclude from 'base/util';
import pagination from './components/searchPagination';
import quickShopping from './components/quickShopping';

$(document).ready(() => {
    processInclude(pagination);
    processInclude(quickShopping);
});
